import { useCallback } from 'react';

import {
  CounterpartyType,
  DropDownHelperService,
  ExpenseTypeService
} from 'openapi';

import { useInterceptor } from 'hooks/useInterceptor';

export const useAdditionalFieldsController = () => {
  const { interceptRequest } = useInterceptor();

  const { getAllDropDownExpenseTypes } = ExpenseTypeService;

  const {
    getAllCurrenciesForDropDown,
    getAllDropDownCounterparties,
    getAllTagsByCompanyIdForDropDown,
    getAllBanksForDropDown
  } = DropDownHelperService;

  const getExpenseTypes = useCallback(
    (id: number) => interceptRequest(getAllDropDownExpenseTypes, {}, id),
    [getAllDropDownExpenseTypes]
  );

  const getCurrencies = useCallback(
    () => interceptRequest(getAllCurrenciesForDropDown, {}),
    [getAllCurrenciesForDropDown]
  );

  const getAllDropDownCounterpartiesByCompany = useCallback(
    (companyId: number, type: CounterpartyType, searchParam?: string) =>
      interceptRequest(
        getAllDropDownCounterparties,
        {},
        companyId,
        type,
        searchParam
      ),
    [getAllDropDownCounterparties]
  );

  const getAllTagsByCompanyId = useCallback(
    (companyId: number) =>
      interceptRequest(getAllTagsByCompanyIdForDropDown, {}, companyId),
    [getAllTagsByCompanyIdForDropDown]
  );

  const getAllBanks = useCallback(
    () => interceptRequest(getAllBanksForDropDown, {}),
    [getAllBanksForDropDown]
  );

  return {
    getExpenseTypes,
    getCurrencies,
    getAllDropDownCounterpartiesByCompany,
    getAllTagsByCompanyId,
    getAllBanks
  };
};
